var values = require('lodash.values');
var find = require('lodash.find');
var omit = require('lodash.omit');
var forEach = require('lodash.foreach');
var some = require('lodash.some');

var ppDomains = [
  'precisionplanting.com',
  'fieldviewplus.com',
  'fieldviewcab.com',
  'fieldview.cab'
];

var matchesAny = function(str,arr) {
  return some(arr, function(value) { return str.match(value); });
};

var environment = {

  environments: {
    LOCAL: 'local',
    DEMOSPACE: 'demospace',
    QA1: 'qa1',
    STAGING: 'staging',
    INTEGRATION: 'integration',
    PRODUCTION: 'production'
  },

  salesforce: {
    PRODUCTION: 'orders.climate.com',
    QA1: '.*\.force\.com',
    KNOWLEDGE_US: 'support.climate.com',
    KNOWLEDGE_CA: 'support.climatefieldview.ca',
    KNOWLEDGE_BR: 'support.climatefieldview.com.br',
    KNOWLEDGE_UA: 'support.climatefieldview.com.ua',
    KNOWLEDGE_FR: 'support.climatefieldview.fr',
    KNOWLEDGE_DE: 'support.climatefieldview.de',
    EVENTS: 'events.climate.com'
  },

  serviceDomain: 'api.climate.com',

  serviceProtocol: 'https://',

  getCurrentHostname: function() {
    return window.location.hostname;
  },

  getEnvHostname: function(env, hostname) {
    env = env || 'production';
    hostname = hostname || 'climate.com';
    var envHostnames = {};
    forEach(values(
      omit(this.environments, 'PRODUCTION', 'DEMOSPACE', 'INTEGRATION')),
      function(env) {
        envHostnames[env] = [env, hostname].join('.');
      }
    );
    envHostnames[this.environments.PRODUCTION] = 'www.' + hostname;
    return envHostnames[env];
  },

  isEnv: function(env) {
    if (env === this.environments.PRODUCTION) {
      if (this.getCurrentHostname().replace('twi.', '') === 'climate.com') {
        return true;
      }
      if (this.getCurrentHostname().replace('www.', '') === 'climate.com') {
        return true;
      }
      if (this.getCurrentHostname().replace('orders.', '') === 'climate.com') {
        return true;
      }
      if (this.getCurrentHostname().replace('support.', '') === 'climate.com') {
        return true;
      }
      if (this.getCurrentHostname().replace('events.', '') === 'climate.com') {
        return true;
      }
      if (this.getCurrentHostname().indexOf('climatefieldview') > -1) {
        return true;
      }
      if (this.getCurrentHostname() === 'climate.com') {
        return true;
      }
    } else if (env === this.environments.QA1) {
      if (this.getCurrentHostname().match(this.salesforce.QA1)) {
        return true;
      }
    }
    return this.getCurrentHostname().search(env) >= 0;
  },

  getCurrentEnv: function() {
    return find(values(this.environments), this.isEnv, this);
  },

  isEC2: function () {
    return Boolean(find(omit(this.environments, 'LOCAL'), this.isEnv, this));
  },

  isPrecisionPlanting: function() {
    return matchesAny(this.getCurrentHostname(), ppDomains);
  },

  isSalesforce: function () {
    return matchesAny(this.getCurrentHostname(), values(this.salesforce));
  },

  getServiceHostname:function() {
    switch (this.getCurrentEnv()) {
      case this.environments.LOCAL:
        return this.serviceProtocol +
          this.getEnvHostname(this.environments.LOCAL);
      case this.environments.QA1:
        return this.serviceProtocol + 'qa1-' + this.serviceDomain;
      case this.environments.STAGING:
        return this.serviceProtocol + 'staging-' + this.serviceDomain;
      default:
        return this.serviceProtocol + this.serviceDomain;
    }
  }
};

module.exports = environment;
